import * as React from "react";
import Svg, {
  Circle,
  Path,
  Defs,
  LinearGradient,
  Stop,
} from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={112}
      height={112}
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={56} cy={56} r={56} fill="#fff" />
      <Path
        d="M55 103c25.957 0 47-20.819 47-46.5S80.957 10 55 10 8 30.819 8 56.5 29.043 103 55 103z"
        fill="#1A1A1A"
      />
      <Path
        d="M55.445 53.49c-.057.393-.338.731-1.013 1.069l-2.926 1.463c-.394.168-.9.112-1.126-.282l-6.19-8.103 3.602-1.8c1.632 3.095 7.934 5.74 7.653 7.652z"
        fill="url(#paint0_linear_8490_8650)"
      />
      <Path
        d="M48.805 45.274l-1.013.507c1.97 3.713 10.578 6.752 6.696 8.721l1.013-.506c3.882-1.913-4.727-5.008-6.696-8.722z"
        fill="url(#paint1_linear_8490_8650)"
      />
      <Path
        opacity={0.2}
        d="M55.445 53.488c-.057.394-.338.732-1.013 1.07l-2.926 1.462c-.394.17-.9.113-1.126-.28l-6.19-8.104 1.689-.844c1.575 2.476 4.67 6.077 9.566 6.696z"
        fill="url(#paint2_linear_8490_8650)"
      />
      <Path
        d="M41.433 41.56l3.095 6.245c-1.97.957-3.038.788-3.826.113-.45-.394-.732-.957-1.07-1.576-.337-.619-.562-1.237-.618-1.8-.113-1.013.45-1.97 2.42-2.983z"
        fill="url(#paint3_linear_8490_8650)"
      />
      <Path
        d="M48.523 47.242c-2.813 1.407-4.333 1.07-5.346 0-.506-.506-.9-1.237-1.294-2.025-.394-.788-.731-1.52-.844-2.251-.225-1.463.394-2.87 3.264-4.276-.169.056.056.9.506 1.969a40.647 40.647 0 002.476 4.952c.62 1.069 1.07 1.744 1.238 1.632z"
        fill="url(#paint4_linear_8490_8650)"
      />
      <Path
        d="M44.303 38.746c-.45.225-.844.45-1.238.675-.112.957 3.32 7.878 4.164 8.384.394-.168.844-.337 1.294-.562-.562.281-4.783-8.216-4.22-8.497z"
        fill="url(#paint5_linear_8490_8650)"
      />
      <Path
        d="M69.343 31.6c1.238 2.532 2.195 5.008 2.758 7.146.168.675.337 1.35.45 1.913.45 2.532.225 4.333-.732 4.783 0 0-23.633 2.026-23.69 2.026-.168.056-.506-.338-.956-1.07-1.013-1.575-2.476-4.5-3.095-6.245-.281-.788-.394-1.35-.225-1.407.056-.056 3.995-4.445 7.99-8.834 3.995-4.39 7.934-8.778 7.934-8.778 1.182-.62 3.32.956 5.515 3.826 1.407 1.857 2.813 4.108 4.051 6.64z"
        fill="url(#paint6_linear_8490_8650)"
      />
      <Path
        d="M68.668 31.938c3.32 6.696 3.995 12.154 2.926 12.66-.9.45-3.489-2.363-6.302-7.202-.507-.9-1.07-1.913-1.576-2.983-.506-1.069-1.013-2.082-1.407-3.094-2.194-5.177-2.813-8.947-1.97-9.341 1.07-.563 5.009 3.263 8.329 9.96z"
        fill="url(#paint7_linear_8490_8650)"
      />
      <Path
        d="M71.425 38.97c.844 3.152.844 5.29.169 5.627-.675.338-2.42-1.294-4.445-4.276 1.8-.563 3.32-1.013 4.276-1.35z"
        fill="url(#paint8_linear_8490_8650)"
      />
      <Path
        d="M60.846 21.696c1.07-.507 5.009 3.32 8.328 9.96 3.32 6.696 3.996 12.154 2.926 12.66-.056.056-.112.056-.168.056.9-1.181 0-6.527-2.814-12.21-4.727-9.566-8.272-10.466-8.272-10.466z"
        fill="#A62A00"
      />
      <Path
        d="M60.34 21.978c-.113.056-.225.225-.282.394 1.688 1.631 3.94 4.614 5.965 8.665 2.814 5.627 3.714 10.41 3.264 12.098 1.069 1.182 1.857 1.688 2.307 1.463 1.069-.506.394-5.964-2.926-12.66-3.32-6.697-7.26-10.523-8.328-9.96z"
        fill="url(#paint9_linear_8490_8650)"
      />
      <Path
        d="M35.013 78.5c-.627.547-1.3.987-2.02 1.32-.707.32-1.52.48-2.44.48-1.253 0-2.233-.287-2.94-.86-.693-.573-1.04-1.333-1.04-2.28 0-.453.093-.887.28-1.3.2-.413.513-.767.94-1.06a.253.253 0 00.12-.14.253.253 0 01.12-.14 3.706 3.706 0 011.16-.46c.427-.093.873-.14 1.34-.14.187 0 .373.007.56.02.2.013.347.033.44.06l-.12 2.06a1.245 1.245 0 00-.24-.02 3.002 3.002 0 00-1.2.1c-.24.08-.42.2-.54.36a.855.855 0 00-.18.56c0 .36.147.62.44.78.293.16.647.24 1.06.24.667 0 1.233-.147 1.7-.44a4.76 4.76 0 001.2-1.02l1.36 1.88zm-5.8-2.44a5.927 5.927 0 01-2.02-.56 4.197 4.197 0 01-1.54-1.26c-.4-.547-.6-1.2-.6-1.96 0-.573.14-1.08.42-1.52.293-.44.693-.78 1.2-1.02a3.749 3.749 0 011.7-.38c.933 0 1.66.213 2.18.64.52.427.78.953.78 1.58 0 .36-.067.707-.2 1.04a2.348 2.348 0 01-.66.9l-1.52-.96a.68.68 0 00.2-.28.71.71 0 00.08-.32c0-.24-.073-.413-.22-.52a.893.893 0 00-.54-.16c-.307 0-.567.093-.78.28-.213.173-.32.433-.32.78 0 .373.107.687.32.94.213.253.48.447.8.58.333.12.66.193.98.22l-.26 1.98zm16.203-6.5v2.2h-1.88V82h-2.68v-4.14l.64.72c-.347.293-.714.54-1.1.74-.374.187-.78.327-1.22.42-.427.093-.894.14-1.4.14-.907 0-1.687-.207-2.34-.62-.654-.427-1.18-1-1.58-1.72-.4-.72-.68-1.54-.84-2.46.76-.147 1.326-.373 1.7-.68.373-.32.56-.753.56-1.3 0-.387-.094-.747-.28-1.08a3.305 3.305 0 00-.58-.82l1.64.56h-3.62v-2.2h12.98zm-9.18 2.2l.74-.7c.293.413.526.813.7 1.2.186.387.28.84.28 1.36 0 .613-.18 1.14-.54 1.58-.347.427-.854.773-1.52 1.04.213.453.486.807.82 1.06.346.253.78.38 1.3.38.68 0 1.313-.187 1.9-.56.586-.387 1.066-.933 1.44-1.64l-.5 1.96v-5.68h-4.62zm13.175 0V82h-2.68V71.76h-1.6v-2.2h6.18v2.2h-1.9zm1.599-2.2h12.64v2.2h-1.88V82h-2.68v-5.3h-3.16v.52c0 .533-.114.92-.34 1.16-.227.227-.554.34-.98.34-.307 0-.634-.087-.98-.26a4.514 4.514 0 01-.98-.72 4.879 4.879 0 01-.74-.94c-.187-.347-.28-.673-.28-.98 0-.347.086-.653.26-.92.186-.267.573-.4 1.16-.4h6.04v-2.74h-8.08v-2.2zm26.098 13.8a19.518 19.518 0 01-.66-1.18c-.213-.4-.406-.78-.58-1.14-.173-.36-.306-.64-.4-.84l-.28-1.32a1.748 1.748 0 01-.12-.4 4.803 4.803 0 01-.02-.38c0-.493.18-.847.54-1.06.36-.213.747-.32 1.16-.32.707 0 1.247.193 1.62.58.374.373.56.813.56 1.32 0 .413-.086.74-.26.98-.16.24-.38.433-.66.58-.266.133-.56.26-.88.38l-.74.02c-.2.053-.466.093-.8.12-.32.027-.68.04-1.08.04a8.733 8.733 0 01-1.86-.2 5.846 5.846 0 01-1.68-.68 3.624 3.624 0 01-1.22-1.28c-.293-.533-.44-1.187-.44-1.96 0-.587.107-1.093.32-1.52.227-.44.527-.807.9-1.1.494-.387 1.094-.667 1.8-.84.707-.187 1.5-.28 2.38-.28h.1l-.78.36v-1.48h-5.46v-2.2h11.44v2.2h-3.3v3.34h-1.02c-.773 0-1.373.033-1.8.1a3.96 3.96 0 00-1.08.32 1.6 1.6 0 00-.62.52c-.146.213-.22.467-.22.76 0 .507.207.927.62 1.26.414.32 1.127.48 2.14.48h.22c.08-.013.18-.027.3-.04l2.3 1.22c.187.347.427.753.72 1.22.307.467.647.953 1.02 1.46l-2.18.96zM74.174 69.7c-.226-.787-.446-1.427-.66-1.92-.226-.507-.48-.873-.76-1.1-.293-.24-.666-.36-1.12-.36-.253 0-.493.027-.72.08-.24.053-.453.113-.64.18l-.72-2.1c.32-.133.654-.233 1-.3.334-.067.7-.1 1.1-.1.534 0 1.027.073 1.48.22.454.133.88.393 1.28.78.387.387.76.953 1.12 1.7.347.733.687 1.707 1.02 2.92h-2.38zm1.56-4.14c0-.427.14-.78.42-1.06.28-.28.627-.42 1.04-.42.427 0 .78.14 1.06.42.267.28.4.633.4 1.06 0 .427-.133.787-.4 1.08-.28.28-.633.42-1.06.42-.413 0-.76-.14-1.04-.42a1.505 1.505 0 01-.42-1.08zm7.167 11.7l-.5-9.54h3.38l-.5 9.54H82.9zm-.54 3.34c0-.613.166-1.04.5-1.28.333-.253.74-.38 1.22-.38.466 0 .866.127 1.2.38.333.24.5.667.5 1.28 0 .587-.167 1.013-.5 1.28-.334.253-.734.38-1.2.38-.48 0-.887-.127-1.22-.38-.334-.267-.5-.693-.5-1.28z"
        fill="#fff"
      />
      <Path
        d="M92.038 92.968a.22.22 0 01-.159-.38c9.659-9.657 14.981-22.5 14.981-36.165 0-13.663-5.322-26.507-14.98-36.165a.22.22 0 010-.317.22.22 0 01.317 0c9.741 9.74 15.111 22.701 15.111 36.482 0 13.781-5.363 26.735-15.111 36.483a.219.219 0 01-.159.062zM19.397 92.968a.23.23 0 01-.159-.062C9.49 83.158 4.127 70.204 4.127 56.423c0-13.78 5.363-26.734 15.111-36.482a.22.22 0 01.317 0 .22.22 0 010 .317C9.89 29.916 4.575 42.76 4.575 56.423c0 13.664 5.322 26.508 14.98 36.166a.22.22 0 010 .317.243.243 0 01-.158.062z"
        fill="#00212B"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_8490_8650"
          x1={48.1243}
          y1={46.9461}
          x2={54.5022}
          y2={59.7996}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#921C00" />
          <Stop offset={0.5215} stopColor="#FF6500" />
          <Stop offset={1} stopColor="#921C00" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_8490_8650"
          x1={52.1383}
          y1={49.99}
          x2={63.0295}
          y2={61.1782}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#921C00" />
          <Stop offset={0.5215} stopColor="#FF6500" />
          <Stop offset={1} stopColor="#921C00" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_8490_8650"
          x1={48.0462}
          y1={46.9837}
          x2={54.4242}
          y2={59.8371}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#921C00" />
          <Stop offset={0.5215} stopColor="#FF6500" />
          <Stop offset={1} stopColor="#921C00" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_8490_8650"
          x1={39.7895}
          y1={42.4497}
          x2={42.8109}
          y2={48.5386}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F40" />
          <Stop offset={0.5215} stopColor="#FF9400" />
          <Stop offset={1} stopColor="#F40" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_8490_8650"
          x1={42.0977}
          y1={39.9797}
          x2={46.1751}
          y2={48.1969}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#921C00" />
          <Stop offset={0.5215} stopColor="#FF6500" />
          <Stop offset={1} stopColor="#921C00" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_8490_8650"
          x1={43.5603}
          y1={39.2532}
          x2={47.6381}
          y2={47.471}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#921C00" />
          <Stop offset={0.5215} stopColor="#FF6500" />
          <Stop offset={1} stopColor="#921C00" />
        </LinearGradient>
        <LinearGradient
          id="paint6_linear_8490_8650"
          x1={51.3025}
          y1={25.2037}
          x2={63.3929}
          y2={49.5696}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F40" />
          <Stop offset={0.5215} stopColor="#FF9400" />
          <Stop offset={1} stopColor="#F40" />
        </LinearGradient>
        <LinearGradient
          id="paint7_linear_8490_8650"
          x1={62.2913}
          y1={35.1113}
          x2={86.5823}
          y2={23.0581}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#921C00" />
          <Stop offset={0.5215} stopColor="#FF6500" />
          <Stop offset={1} stopColor="#921C00" />
        </LinearGradient>
        <LinearGradient
          id="paint8_linear_8490_8650"
          x1={67.2809}
          y1={43.4943}
          x2={86.6832}
          y2={33.8668}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#921C00" />
          <Stop offset={0.5215} stopColor="#FF6500" />
          <Stop offset={1} stopColor="#921C00" />
        </LinearGradient>
        <LinearGradient
          id="paint9_linear_8490_8650"
          x1={62.3145}
          y1={24.0935}
          x2={74.0465}
          y2={47.7369}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset={0.00537634} stopColor="#fff" />
          <Stop offset={1} stopColor="#757575" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
